import * as commonScripts from '../common'

const cmpLeadGenForm = {
  component: null,

  init: function (element) {
    const _ = this;
    const modalElement = document.querySelector(".cmp-leadgenform-modal")
    const modalSlideElement = document.querySelector(".cmp-leadgenform-modal .micromodal-slide")

    _.component = element;
    _.heroHeight = 0;
    _.fallbackHeroHeight = "600";
    //console.log(element)
    _.closeBtnFunction()
    if (!(modalElement.classList.contains("modal-popup-only") || modalElement.classList.contains("modal-block-only")) && (modalSlideElement.classList.contains('vertical-align-layout') || modalSlideElement.classList.contains('horizontal-align-layout'))) {
      _.getHeroHeight()
      _.onScrollEvent()
      _.onResizeEvent(element)
      _.onClickEvent(element)   
      
      window.addEventListener('click', (e) => {
        //console.log(e)
        const popup = document.querySelector('.cmp-leadgenform-modal .micromodal-slide')
        const popupContainer = document.querySelector('.cmp-leadgenform-modal__container')
        const popupContainerEle = document.querySelector('.same-as-selected')
        let optionalFormId = ''
        let isOptionalForm = false
        if (popup.classList.contains('is-open')) {
          // console.log(popup.contains(e.target))
          // console.log(popupContainer.contains(e.target))
          // console.log(popupContainerEle.contains(e.target))
          // console.log(e.target)
          // console.log(e)

          if(popup.querySelector('[data-optional-form-id]') != null){
            optionalFormId = 'form-' + popup.querySelector('[data-optional-form-id]').getAttribute('data-optional-form-id')
            localStorage["optionalFormId"] = optionalFormId;
          }

          if(localStorage["optionalFormId"] != null){
            isOptionalForm = popup.querySelector('#'+ localStorage["optionalFormId"]) != null
          }

          if (!(popup.contains(e.target) || popup.querySelector('[data-optional-form-id]') == null || popupContainer.contains(e.target) || (popupContainerEle != null && popupContainerEle.contains(e.target))) || (!popup.contains(e.target) && isOptionalForm)){
            //console.log("hi")
            document.querySelector('.cmp-leadgenform-modal .micromodal-slide').classList.remove('is-open')
            document.querySelector('.modal-popup-with-blur').classList.remove('enableBlur')
            document.querySelector('body').removeAttribute('style')
            if(!document.querySelector('.cmp-leadgenform-modal').classList.contains(('disableBlur'))){
              document.querySelector('.cmp-leadgenform-modal').classList.add('disableBlur')
            }
          }
        }
      });
    }
    else if(modalElement.classList.contains('modal-popup-only')) {
      document.querySelector('body').setAttribute('style', 'overflow: hidden; user-select: none; pointer-events: none;')
      // let mainSection = document.getElementById('mainSection')
      // if(mainSection != null){
      //   mainSection.classList.add('enableBlur')
      // }
      // else {
      //   document.getElementById('main').classList.add('enableBlur')
      // }
      // document.querySelector('header.cmp-header').classList.add('enableBlur')
      const submitbutton = document.querySelector(".cmp-leadgenform-modal .btn-primary.form-submit-btn")
      if (submitbutton != null) {
        submitbutton.addEventListener("click", (e) => {
          document.querySelector('.cmp-leadgenform-modal__close').classList.remove('hide')
          //console.log("submit")
          document.querySelector('.cmp-leadgenform-modal__close').removeAttribute("disabled")
          
          //document.querySelector('.modal-popup-only .cmp-leadgenform-modal__overlay .response-section').classList.add('is-visible')
          _.closeBtnFunction()
        })
      }
    }
  },

  closeBtnFunction: function(){
    const closebutton = document.querySelector(".cmp-leadgenform-modal__close")
    closebutton.addEventListener("click", (e) => {
        document.querySelector('.cmp-leadgenform-modal .micromodal-slide').classList.remove('is-open')
        document.querySelector('body').removeAttribute('style')
        if(document.querySelector('.modal-popup-with-blur') != null && document.querySelector('.modal-popup-with-blur').classList.contains('enableBlur'))
        {
          document.querySelector('.modal-popup-with-blur').classList.remove('enableBlur')
        }
        if(!document.querySelector('.cmp-leadgenform-modal').classList.contains(('disableBlur'))){
          document.querySelector('.cmp-leadgenform-modal').classList.add('disableBlur')
        }
      })
  },

  getHeroHeight: function () {
    const heroContainer = document.querySelector('.cmp-hero');
    const heroCarouselContainer = document.querySelector('.cmp-hero-carousel');
    const _ = this;

    if (heroContainer) {
      _.heroHeight = heroContainer.offsetHeight;

    } else if (heroCarouselContainer) {
      _.heroHeight = heroCarouselContainer.offsetHeight;

    } else {
      _.heroHeight = _.fallbackHeroHeight;
    }
  },

  onScrollEvent: function () {
    const _ = this
    window.addEventListener('scroll', () => {
      'use strict'
      if (
        document.body.scrollTop >= _.heroHeight ||
        document.documentElement.scrollTop >= _.heroHeight
      ) {
        _.component.classList.add('visible');
      } else {
        _.component.classList.remove('visible');
        document.querySelector('.cmp-leadgenform-modal .micromodal-slide').classList.remove('is-open')
        document.querySelector('body').removeAttribute('style')
      }
    });
  },

  onClickEvent: function (element) {    
    const _ = this;
    element.querySelector('a').addEventListener('click', _.OpenModalPopup)
  },

  onResizeEvent: function (element) {
    const _ = this;
    const iconLink = element.querySelector('a')
    window.addEventListener('resize', function () {
      iconLink.removeEventListener('click', _.OpenModalPopup);
      _.getHeroHeight();
      iconLink.addEventListener('click', _.OpenModalPopup);
    }, false);
  },

  OpenModalPopup: function (e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    const mainTag = document.querySelector('main');
      if (mainTag && mainTag.querySelector('.modal-popup-with-blur')) {
        const blurElements = mainTag.querySelectorAll('.modal-popup-with-blur');
        blurElements.forEach(el => el.parentNode.removeChild(el));
      }
    const modal = document.querySelector('.cmp-leadgenform-modal');
    
    if (modal) {
      const formBlocks = modal.querySelectorAll('.cmp-contact-standard-block');
      formBlocks.forEach(block => block.removeAttribute('style'));
    }
    document.querySelector('.cmp-leadgenform-modal .micromodal-slide').classList.add('is-open')
    document.querySelector('body').setAttribute('style', 'overflow: hidden')
    document.querySelector('.modal-popup-with-blur').classList.add('enableBlur')
  }
}
export default cmpLeadGenForm
